import React from "react";

const Condition = ({
  children,
}: {
  children: React.ReactElement[] | React.ReactElement;
}) => {
  return <>{children}</>;
};

Condition.IF = ({
  condition,
  children,
}: {
  condition: boolean;
  children: React.ReactElement[] | React.ReactElement;
}) => {
  return condition ? <>{children}</> : null;
};

Condition.ELSE = ({ children }: { children: React.ReactElement }) => {
  return <>{children}</>;
};

export default Condition;
